import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const styles = {
  button: {
    padding: '1px',
    backgroundColor: '#fc9',
    pointerEvents: 'none'
  },
  boxPanel: {
    padding: '15px 10px'
  }
};

const enhance = compose();

const TabPanelDetail = enhance(props => {
  const { children, value, index } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
    >
      <Box p={3} style={styles.boxPanel}>
        {children}
      </Box>
    </div>
  );
});

export default withRouter(withStyles(styles)(TabPanelDetail));
